import { BUYABLE_FLOWERS, FLOWERS } from '../../game/flowers';
import { UPGRADE_IDS, UPGRADES } from '../../game/upgrades';
import { ui } from '../store';

export function Toasts() {
  return (
    <div class="toasts" role="status" aria-live="polite">
      {ui.toasts.value.map((t) => (
        <div key={t.id} class={`toast toast-${t.tone}`}>
          {t.text}
        </div>
      ))}
    </div>
  );
}

export function HoverTooltip() {
  const hover = ui.hover.value;
  if (!hover) return null;
  const left = Math.min(hover.x + 18, window.innerWidth - 260);
  return (
    <div
      class={`hover-tip tone-${hover.tone}`}
      style={{ left: `${left}px`, top: `${hover.y + 18}px` }}
    >
      {hover.label}
    </div>
  );
}

export function LevelUpModal() {
  const level = ui.levelUp.value;
  if (level === null) return null;
  const seeds = BUYABLE_FLOWERS.filter((id) => FLOWERS[id].unlockLevel === level);
  const upgrades = UPGRADE_IDS.filter((id) => UPGRADES[id].unlockLevel === level);
  return (
    <div class="panel-backdrop" onClick={() => (ui.levelUp.value = null)}>
      <div
        class="panel levelup"
        role="dialog"
        aria-modal="true"
        aria-label={`Level ${level}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div class="levelup-burst" aria-hidden="true">
          🎉
        </div>
        <h2>Level {level}!</h2>
        <p>Your little homestead is blooming.</p>
        {(seeds.length > 0 || upgrades.length > 0) && (
          <ul class="unlocks">
            {seeds.map((id) => (
              <li key={id}>
                {FLOWERS[id].emoji} <b>{FLOWERS[id].name}</b> seeds at the market
              </li>
            ))}
            {upgrades.map((id) => (
              <li key={id}>
                {UPGRADES[id].emoji} <b>{UPGRADES[id].name}</b> upgrade
              </li>
            ))}
          </ul>
        )}
        <button class="big-button" onClick={() => (ui.levelUp.value = null)} autoFocus>
          Yay! 🌸
        </button>
      </div>
    </div>
  );
}

export function SleepOverlay() {
  return (
    <div class={`sleep-overlay ${ui.sleeping.value ? 'show' : ''}`} aria-hidden="true">
      <span>Zzz… 🌙</span>
    </div>
  );
}
